import { Box, Stack } from '@mui/material';
import { MobileTabs } from 'lib/mobileDesignSystem';
import React from 'react';
import { useSearchParams } from 'react-router-dom';

import {
  FINANCE_DEFAULT_TAB,
  FINANCE_TAB_ITEMS,
  getTabComponent,
} from './tabConfig';

const FinanceTabsView: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') ?? FINANCE_DEFAULT_TAB;

  const setActiveTab = (tab: string) => {
    setSearchParams({ tab }, { replace: true });
  };

  const TabContent = getTabComponent(activeTab);

  return (
    <Stack sx={{ flex: 1, minHeight: '100%' }}>
      <Box sx={{ pt: 2, pb: 1, px: 2 }}>
        <MobileTabs
          value={activeTab}
          items={FINANCE_TAB_ITEMS}
          onChange={setActiveTab}
        />
      </Box>
      {TabContent != null && <TabContent />}
    </Stack>
  );
};

export default FinanceTabsView;
